<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <button v-if="!loading" type="button" class="btn btn-fill btn-info btn-auto" @click.prevent="importSelected">Import Selected Amazon Products</button>
        <button v-if="loading" type="button" class="btn btn-info btn-auto" disabled="disabled">
          <span class="btn-label">
            <i class="fa fa-circle-o-notch fa-spin"></i>
          </span>
          Loading...
        </button>
      </div>
      <div class="col-md-4 pull-right">
        <div style="float: right;">
          <p class="category">Import All</p>
          <p-switch v-model="importAll" type="primary" on-text="ON" off-text="OFF"></p-switch>
        </div>
      </div>
    </div>
    <div v-if="initialized" class="row">
      <div v-for="amzProd in amzProducts" class="col-lg-4" :key="amzProd.id">
        <div class="card" style="padding-top:10px;">
          <div class="text-center">
            <div class="row">
              <h4 v-tooltip="amzProd.data.AttributeSets.ItemAttributes.Title">{{limitChars(amzProd.data.AttributeSets.ItemAttributes.Title)}}</h4>
            </div>
          </div>
          <hr>
          <div class="text-center prod-img-container">
            <img :src="amzProd.data.AttributeSets.ItemAttributes.SmallImage.URL" alt="Image">
          </div>
          <div class="text-center">
            <div class="row">
              <div class="form-group">
                <label>Brand ({{amzProd.data.AttributeSets.ItemAttributes.Brand}})</label><br>
                <el-select class="select-primary"
                            size="large"
                            placeholder="Single Select"
                            v-model="amzProd.brandIndex"
                            @change="brandChanged(amzProd)">
                    <el-option v-for="(option, index) in brands"
                              class="select-danger"
                              :value="index"
                              :label="option.name"
                              :key="option.name">
                    </el-option>
                  </el-select>
              </div>
            </div>
            <div v-if="amzProd.data.AttributeSets.ItemAttributes.Size" class="row">
              <strong>Size:</strong> {{amzProd.data.AttributeSets.ItemAttributes.Size}}
            </div>
            <div v-if="amzProd.data.AttributeSets.ItemAttributes.Color" class="row">
              <strong>Color:</strong> {{amzProd.data.AttributeSets.ItemAttributes.Color}}
            </div>
            <div v-if="amzProd.data.FNSKU">
              <strong>FNSKU:</strong> {{amzProd.data.FNSKU}}
            </div>
            <div v-if="amzProd.id">
              <strong>SKU:</strong> {{amzProd.id}}
            </div>
          </div>
          <hr>
          <div class="text-center" style="height: 40px;">
            <div v-if="amzProd.loading">{{ amzProd.status }}</div>
            <div v-if="!amzProd.loading">
              <span>Import</span>
              <p-switch v-model="amzProd.import" type="primary" on-text="YES" off-text="NO"></p-switch>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import db from '@/components/firebase/init'
  import firebase from 'firebase'
  import { toolboxMixin } from '@/components/mixins/toolboxMixin'
  import { EventBus } from '@/eventBus'
  import PSwitch from 'src/components/UIComponents/Switch.vue'

  export default {
    components: {
      PSwitch
    },
    mixins: [toolboxMixin],
    data () {
      return {
        authDetails: {},
        initialized: false,
        amzProducts: [],
        importAll: false,
        brands: [],
        brandNameIndexMap: new Map(),
        loading: true,
        existingProductSkus: new Map()
      }
    },
    methods: {
      async init () {
        this.authDetails = await this.getAuthDetails()
        await this.getBrands()
        await this.getExistingProductSkus()
        this.initialized = true
        this.loading = false
        this.getAmzProducts()
      },
      async getBrands () {
        this.brands = []
        this.brands.push({
          id: 0,
          name: 'Please Select'
        })
        this.brandNameIndexMap.set('Please Select', 0)
        let qs = await db.collection(`brands`).where('accountId', '==', this.authDetails.account.id).orderBy('name').get()
        for (const doc of qs.docs) {
          let brand = doc.data()
          brand.id = doc.id
          console.log('brand', brand)
          this.brands.push(brand)
          this.brandNameIndexMap.set(brand.name, this.brands.length - 1)
        }
      },
      getBrandIndex (brandName) {
        console.log('getting brand index for', brandName)
        let index = 0
        if (!this.brandNameIndexMap.get(brandName)) index = 0
        else index = this.brandNameIndexMap.get(brandName)
        console.log('index is', index)
        return index
      },
      getAmzProducts () {
        db.collection(`accounts/${this.authDetails.account.id}/amzProducts`)
        .onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            if (change.type === 'added') {
              let doc = change.doc
              let prod = {
                id: doc.id,
                data: doc.data(),
                brandIndex: 0
              }
              prod.import = false
              this.applyFirstMatchingBrand(prod)
              if (this.existingProductSkus.get(prod.id)) {
                prod.imported = true
                prod.loading = true
                prod.status = 'Already imported'
              }
              this.amzProducts.push(prod)
            }
          })
        })
      },
      applyFirstMatchingBrand (amzProd) {
        let brandStr = amzProd.data.AttributeSets.ItemAttributes.Brand
        if (brandStr.includes(',')) {
          let brands = brandStr.split(',')
          for (const brand of brands) {
            let str = brand.trim()
            if (this.getBrandIndex(str) !== 0) {
              amzProd.brandIndex = this.getBrandIndex(str)
              return
            }
          }
        }
        amzProd.brandIndex = this.getBrandIndex(amzProd.data.AttributeSets.ItemAttributes.Brand)
        if (amzProd.brandIndex === 0) {
          amzProd.loading = true
          amzProd.status = 'Please select brand'
        }
      },
      async getExistingProductSkus () {
        console.log('getting products')
        this.existingProductSkus = new Map()
        let userToken = await firebase.auth().currentUser.getIdToken()
        let data = {
          userToken: userToken,
          accountId: this.authDetails.account.id,
          archivedOnly: false
        }
        let getAccountProducts = firebase.functions().httpsCallable('getAccountProducts')
        let result = await getAccountProducts(data)
        for (const prod of result.data.products) {
          let product = prod.data
          product.id = prod.id
          this.existingProductSkus.set(product.sku, product)
        }
      },
      brandChanged (amzProd) {
        if (amzProd.imported) {
          // leave everything alone, should already be marked as loading with status msg
        } else if (amzProd.brandIndex === 0) {
          amzProd.loading = true
          amzProd.status = 'Please select brand'
        } else {
          amzProd.loading = false
        }
      },
      limitChars (x) {
        if (x.length > 30) return x.substring(0, 30) + '...'
        return x
      },
      async importSelected () {
        this.loading = true
        var hasErrors = false
        var qtyImport = 0
        for (const aprod of this.amzProducts) {
          if (aprod.import) {
            await this.importAmazonProduct(aprod)
          }
        }
        this.loading = false
        this.$router.replace({ name: 'Products' })
      },
      async importAmazonProduct (amzProd) {
        try {
          amzProd.loading = true
          amzProd.status = 'loading'
          let data = {
            sellerSku: amzProd.id,
            brandId: this.brands[amzProd.brandIndex].id,
            amzProdData: amzProd.data
          }
          data.userToken = await firebase.auth().currentUser.getIdToken()
          let accountImportAmazonProduct = firebase.functions().httpsCallable('accountImportAmazonProduct')
          let result = await accountImportAmazonProduct(data)
          amzProd.status = 'imported'
          this.showNotify(`Imported: ` + amzProd.data.AttributeSets.ItemAttributes.Title, 'success', 'Success')
        } catch (err) {
          amzProd.status = 'failed'
          this.showNotify(err, 'danger', 'Failed')
        }
      }
    },
    watch: {
      importAll: function (newVal, oldVal) {
        for (const amzProd of this.amzProducts) {
          amzProd.import = newVal
        }
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        this.init()
      })
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Amazon/Amazon.vue